import getters from './getters';
import mutations from './mutations';
// eslint-disable-next-line import/no-cycle
import actions from './actions';

const state = {
  amountOfRunningProjects: {},
  lastAddingConfigurationActionData: {
    running: false,
    configType: null,
  },
  subdomainsForTld: [],
  emailsForTld: [],
  lastCTCNode: {},
  hostsForSubdomain: [],
  riskScoreHistoryPerTld: {},
  projectListLoading: false,
  dataLoading: false,
  configurationCloudAssets: [],
  configurationBucketAssets: [],
  configurationServicesAssets: [],
  configurationServicesComplianceOptions: {
    FAIL: 0,
    PASS: 0,
    INFO: 0,
  },
  cloudServicesSecondLevelItems: [],
  cloudServicesThirdLevelItems: [],
  cloudServicesFourthLevelItems: {},
  servicesAssetsListOptions: {
    sort: {
      date: 'desc',
    },
    limit: 20,
    page: 1,
    search: '',
    complianceItems: [],
    regions: [],
  },
  cloudAccountsListOptions: {
    sort: {
      configData: 'desc',
    },
    limit: 20,
    page: 1,
    search: '',
  },
  configurationSubdomains: [],
  configurationHosts: [],
  configurationDomains: [],
  configurationOrganizationTags: [],
  configurationCloudAccounts: [],
  configurationSubdomainTags: [],
  configurationDomainTags: [],
  configurationCloudAccountTags: [],
  configurationAuthenticationObjects: [],
  portsToScoreMap: {},
  panoramicData: null,
  testCardsHosts: {},
  testCardsSubdomains: {},
  testCardsCloudAccounts: {},
  testCardsDomains: {},
  hasDiscoveryFinished: {},
  testCardsDomainsLastScannedDate: {},
  testCardsPasswordSpray: {},
  testCards: {},
  testTypes: [],
  projects: [],
  projectListOptions: {
    sort: {
      createdDate: 'desc',
    },
    // While we don’t implement lazy loading we have 25 records limit on BE by default.
    // For quick fix we should remove this limit.
    limit: 0,
  },
  detailedProject: null,
  projectLoading: false,
  deleteConfigurationLoading: false,
  addTagsIntervalRunning: false,
  addTagsRefId: '',
  projectsRefId: '',
  projectsRunningInterval: false,
  projectsProgress: 0,
};

export default {
  state,
  getters,
  mutations,
  actions,
};
